import Helpers from '../Helpers'

class ResultsPagination {
    constructor(changeEvent) {
        this.changeEvent = changeEvent

        this.control = document.getElementsByClassName('results-list__utility')[0]

        this.pageTitle = document.getElementsByClassName('results-list__no-results')[0]

        this.pagePrev = document.getElementsByClassName('results-list__paging-control--prev')[0]
        this.pageNext = document.getElementsByClassName('results-list__paging-control--next')[0]
        this.listeners()
    }

    listeners() {
        new Helpers(this.pageNext).eventListener((e) => {
            e.preventDefault()
            const pMax = parseInt(this.control.getAttribute('data-pMax'))
            
            if (pMax === 0) {
                //return if showing "all pages"
                return
            }
            const nextPage = pMax + 1
            const maxPages = parseInt(this.control.getAttribute('data-pages'))

            if (nextPage > maxPages) {
                // would end up outside result set
                return
            }
            

            this.control.setAttribute('data-pMin', nextPage)
            this.control.setAttribute('data-pMax', nextPage)

            this.updatePaginationControls()
            this.changeEvent('page')
        })
        new Helpers(this.pagePrev).eventListener((e) => {
            e.preventDefault()
            const pMin = parseInt(this.control.getAttribute('data-pMin'))
            if (pMin === 0) {
                //showing all pages
                return
            }
            const prevPage = pMin - 1

            if (prevPage < 1) {
                // would end up outside result set
                return
            }

            this.control.setAttribute('data-pMin', prevPage)
            this.control.setAttribute('data-pMax', prevPage)
            
            this.updatePaginationControls()
            this.changeEvent('page')
        })
        
    }

    page() {
        return parseInt(this.control.getAttribute('data-pMax'))
    }
    setNoOfPages(pages) {
        this.control.setAttribute('data-pages', pages)
        this.updatePaginationControls()
    }

    updatePaginationControls() {
        const maxPages = parseInt(this.control.getAttribute('data-pages'))
        const pMin = parseInt(this.control.getAttribute('data-pMin'))
        const pMax = parseInt(this.control.getAttribute('data-pMax'))
        if (maxPages === 0) {
            this.pageTitle.innerHTML = 'No results'
        } else if (pMax === 0) {
            this.pageTitle.innerHTML = 'All pages'
        } else if (pMax === pMin) {
            this.pageTitle.innerHTML = `Page ${pMax} of ${maxPages}`
        } else {
            this.pageTitle.innerHTML = `Page ${pMin}-${pMax} of ${maxPages}`
        }

        this.pagePrev.setAttribute('data-disabled', pMin <= 1 || pMin === 0 ? 'true' : 'false')
        this.pageNext.setAttribute('data-disabled', pMax >= maxPages || pMax === 0 ? 'true' : 'false')
    }

    showMore() {
        const maxPages = parseInt(this.control.getAttribute('data-pages'))
        const pMax = parseInt(this.control.getAttribute('data-pMax'))
        if (maxPages > pMax) {
            this.control.setAttribute('data-pMax',pMax+1)
        }
    }

    setValues(values) {
        this.control.setAttribute('data-pMin', values.pMin === undefined ? 1 : values.pMin)
        this.control.setAttribute('data-pMax', values.pMax === undefined ? 1 : values.pMax)
    }

    getValues() {
        return {
            pMin: parseInt(this.control.getAttribute('data-pMin')),
            pMax: parseInt(this.control.getAttribute('data-pMax'))
        }
    }

    getNonDefaultValues() {
        const values = this.getValues()
        Object.keys(values).forEach((key) => (values[key] === 1) && delete values[key])
        return values
    }
}

export default ResultsPagination